import { render, staticRenderFns } from "./TemplateAIR.vue?vue&type=template&id=f6af18e4&scoped=true&"
import script from "./TemplateAIR.vue?vue&type=script&lang=js&"
export * from "./TemplateAIR.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAIR.vue?vue&type=style&index=0&id=f6af18e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af18e4",
  null
  
)

export default component.exports